import { render, staticRenderFns } from "./Dots.vue?vue&type=template&id=c61ef0a2&scoped=true&"
import script from "./Dots.vue?vue&type=script&lang=ts&"
export * from "./Dots.vue?vue&type=script&lang=ts&"
import style0 from "./Dots.vue?vue&type=style&index=0&id=c61ef0a2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c61ef0a2",
  null
  
)

export default component.exports